<template>
<div>


<!--   <Section background="white"  class="image-bg"-->
<!--            :style="{'background-image': `url(${require('../../assets/images/content/pexels-pixabay-414781-cropped.jpg')})`}"-->

<!--   >-->

<!--      <nav-bar dark></nav-bar>-->
<!--      &lt;!&ndash;      <div class=" main-heading heading-line pt-1">&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->

<!--&lt;!&ndash;      <div class=" main-heading heading-line" style=" width: 100%;" >&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->

<!--      <div class=" main-heading" style=" width: 100%;" >-->
<!--         <v-container fluid class="heading-line">-->
<!--            <div class="center display-2">Videos</div>-->
<!--         </v-container>-->
<!--      </div>-->


<!--   </Section>-->







   <section class="pa-9">
      <article >

         <h1>some doc</h1>
         <p> something
         </p>

         <div class="flex-center">
         
         </div>



      </article>

   </section>



</div>
</template>

<script>

import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";
import AudioPlayer from "@/components/AudioPlayer";

export default {
name: "Docs",
   components: {navBar, Section, AudioPlayer},
}
</script>

<style scoped>
.image-bg{
   background-size: cover;
   background-position: center;
   height: 300px;
}

   td{
      padding-left: 10px;
      padding-right: 10px;
   }


.main-heading{
   height: 200px;
   display: flex;
   align-items: center;
   justify-content: center;

}


.heading-line{
   text-align: center;
   color:#ffffff;
   /*background-color:rgba(43,43,43,0.4);*/
   width: 100%;

}

</style>
